import {BrowserRouter, Route, Routes, Outlet, Navigate} from 'react-router-dom'
import TestPage from '../pages/TestPage'
import AuthPage from '../pages/AuthPage/AuthPage'
import MainPage from '../pages/MainPage/MainPage'
import AdminSettingsPage from '../pages/AdminPage/AdminSettingsPage'
import RestorePasswordPage from '../pages/AuthPage/RestorePasswordPage'
import ComparisonAuditsPage from '../pages/ComparisonAuditsPage/ComparisonAuditsPage'
import ArchiveAuditPage from '../pages/HistoryAuditPage/ArchiveAuditPage'
import AdminUsers from '../pages/AdminPage/AdminUsers'
import AdminFacilities from '../pages/AdminPage/AdminFacilities'
import AdminTests from '../pages/AdminPage/AdminTests'
import AdminLogs from '../pages/AdminPage/AdminLogs'
import PlaningAuditPage from '../pages/PlaningAuditPage/PlaningAuditPage'
import AdminTestStructure from '../pages/AdminPage/AdminTestStructure'
import ChangeAuditPage from '../pages/ChangeAuditPage/ChangeAuditPage'
import AuditPage from '../pages/AuditTestPage/AuditPage'
import AuditResultPage from '../pages/AuditResultPage/AuditResultPage'
import { AdminRoute, AuthRoute, ModeratorRoute, PrivateRoute } from './authCheck'
import { CalendarPage } from '../pages/CalendarPage/CalendarPage'
import { DashboardPage } from '../pages/DashboardPage/DashboardPage'
import { DashboardPageInfo } from '../pages/DashboardPage/DashboardPageInfo'

export default function AppRoutes(){
    return(
        <>
        <BrowserRouter>
            <Routes>
                <Route path='/test_page' element={<TestPage/>} />
                <Route element={<AuthRoute/>}>
                    {/* <Route path='*' element={<AuthPage/>} /> */}

                    <Route path="/" element={<AuthPage/>}/>
                    <Route path="/:username/reset_password/:reset_code" element={<RestorePasswordPage/>}/>
                </Route>

                <Route element={<PrivateRoute />}>
                    <Route path="/main_page" element={<MainPage/>}/>
                    <Route path="/calendar_page" element={<CalendarPage/>}/>
                    {/* <Route path="/dashboard_page" element={<DashboardPage/>}/> */}
                    {/* <Route path="/dashboard_page/:id" element={<DashboardPageInfo/>}/> */}

                    <Route path="/compare_results_audit" element={<ComparisonAuditsPage/>}/>
                    <Route path="/archive_results_audit" element={<ArchiveAuditPage/>}/>

                    <Route element={<AdminRoute />}>
                        <Route path="/admin_page_settings" element={<AdminSettingsPage/>}/>
                        <Route path="/admin_page_settings/users" element={<AdminUsers/>}/>
                        <Route path="/admin_page_settings/facilities" element={<AdminFacilities/>}/>
                        <Route path="/admin_page_settings/tests" element={<AdminTests/>}/>
                        <Route path="/admin_page_settings/tests/:test_id" element={<AdminTestStructure/>}/>
                        <Route path="/admin_page_settings/logs" element={<AdminLogs/>}/>
                    </Route>

                    <Route element={<ModeratorRoute/>}>
                        <Route path="/planing_audit" element={<PlaningAuditPage/>}/>
                        <Route path="/change_audit/:audit_id" element={<ChangeAuditPage/>}/>
                    </Route>

                    <Route path="/audit_page/:audit_id" element={<AuditPage/>}/>
                    <Route path="/audit_result_page/:audit_id" element={<AuditResultPage/>}/>
                </Route>

            </Routes>
        </BrowserRouter>
        </>
    )
}